export interface AttachedDocuments {
  fullPathName: string;
  documentName: string;
  dateStored: Date;
  storedBy: string;
}
